/**
 * Copyright (C) 2026 Jugendstil, SLU - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited. Proprietary and confidential.
 */

/**
 * The two events that are the library's only JavaScript-facing contract.
 *
 * `wp:paint` is raised by a page that changed markup the library owns without a navigation to
 * notice it by. `wp:commit` is raised by a form about to be posted, and is how a control that
 * cannot be read continuously - a wheel mid-scroll - is asked for its value at the one moment the
 * answer has to be true.
 *
 * Declared on `DocumentEventMap` so that both the dispatch and the listen side are checked. A
 * consumer that dispatches `wp:commit` with the wrong detail shape is a compile error here rather
 * than a control that silently keeps its old value.
 */
export interface RootDetail {
    readonly root?: Element | undefined;
}

declare global {
    interface DocumentEventMap {
        'wp:commit': CustomEvent<RootDetail | undefined>;
        'wp:paint': CustomEvent<RootDetail | undefined>;
    }
}

/** The subtree an event narrows to, or the whole document when it names none. */
export function rootOf(event: CustomEvent<RootDetail | undefined>): ParentNode {
    const root = event.detail?.root;

    return root instanceof Element ? root : document;
}
